// TELEFON NIQOBI — formula SERVERNIKI, panelda ixtiro qilinmagan.
//
// =====================================================================
// ⛔ MANBA: `uz.xsib.common.contact.Phones#mask` (`Phones.java:141-150`)
// =====================================================================
// Formula AYNAN ko'chirildi va o'lchandi (2026-08-24):
//
//   · `null` yoki faqat bo'shliq  -> `null` (satr EMAS)
//   · `trim()` DAN KEYIN o'lchanadi
//   · uzunlik < 9                 -> butunlay yulduzcha, AYNI uzunlikda
//   · aks holda                   -> birinchi 5 + `****` + oxirgi 3
//
// ⚠️ QISQA QIYMAT BUTUNLAY YOPILADI va bu serverning ongli qarori
// (`Phones.java:132-134`): 9 belgidan kam raqamda boshi va oxiri birga
// raqamning O'ZINI tiklab berardi.
//
// ⚠️ NATIJA UZUNLIGI 9+ da HAR DOIM 12 belgi — o'rtadagi belgilar birma-bir
// almashtirilmaydi, TASHLANADI. Ya'ni niqobdan asl uzunlikni bilib
// bo'lmaydi va bu ham himoyaning bir qismi.
//
// ⛔ NEGA `Phones.mask` NING NUSXASI, «shunchaki nuqta qo'yish» EMAS.
// Bir tizimda ikki xil niqob bo'lmasligi kerak: admin panelida
// `/crm/leads` allaqachon `+9989****233` ko'rinishini chizadi va u
// serverdan tayyor keladi. Panelda boshqa shakl yasalsa, ayni raqam ikki
// ekranda ikki xil ko'rinardi va operator ularni BOSHQA raqam deb
// o'qirdi.
//
// ⛔ NEGA SERVERNING O'ZI NIQOBLAMAYDI (o'lchandi, `ContactView.java:9-27`):
// sheriklar kabineti kontaktni `GET /api/subscribers/{id}/contact` orqali
// oladi va u yo'l `.masked()` ni ATAYLAB chaqirmaydi — chunki `PUT`
// TO'LIQ ALMASHTIRISH va niqob IDEMPOTENT EMAS: formadan qaytgan
// niqoblangan qiymat haqiqiy raqamni bosib yozardi va uni tiklab
// bo'lmasdi. Shuning uchun niqob FAQAT CHIZISH paytida qo'llanadi —
// ma'lumot qatlamiga TEGMAYDI ({@link maskPhone} ning yagona
// iste'molchisi `shared/ui/MaskedPhone.tsx`).

/** Serverning chegarasi: shundan qisqa qiymat BUTUNLAY yopiladi */
export const PHONE_MASK_MIN_LENGTH = 9

/**
 * ⚠️ YULDUZCHA — servernikining aynan o'zi. Nuqta yoki boshqa belgi
 * qo'yilsa `isMaskedValue` (`contactDraft.ts`) niqoblangan qiymatni
 * TANIMAY qolardi, u esa formani mavjud raqamni bosib yozishdan
 * saqlaydigan YAGONA to'siq.
 */
const MASK_CHAR = '*'

/**
 * Raqamning niqoblangan ko'rinishi.
 *
 * @returns `null` — qiymat yo'q yoki bo'sh (serverning xulqi aynan shu)
 */
export function maskPhone(phone: string | null | undefined): string | null {
  if (phone === null || phone === undefined) return null
  const trimmed = phone.trim()
  if (trimmed === '') return null
  if (trimmed.length < PHONE_MASK_MIN_LENGTH) {
    return MASK_CHAR.repeat(trimmed.length)
  }
  return `${trimmed.slice(0, 5)}${MASK_CHAR.repeat(4)}${trimmed.slice(-3)}`
}

/**
 * Qiymat ALLAQACHON niqoblanganmi (serverdan shunday kelganmi).
 *
 * ⚠️ `contactDraft.isMaskedValue` bilan AYNI qoida va AYNI belgi.
 * Takrorlanmasin uchun u yerdan olinmadi: `contactDraft.ts`
 * `features/subscriber` da, bu esa `shared/` da va uni kassa moduli ham
 * ishlatadi — `features/*` bir-birini import qilmaydi (07-FRONTEND §6).
 */
export function isAlreadyMasked(value: string | null | undefined): boolean {
  return typeof value === 'string' && value.includes(MASK_CHAR)
}

/**
 * Ekranda ko'rsatiladigan qiymat.
 *
 * ⚠️ Serverdan NIQOBLANGAN kelgan qiymat QAYTA niqoblanmaydi: niqob
 * idempotent emas (`Phones.mask` — 12 belgili niqob yana kesilardi) va
 * ikki marta qo'llash qiymatni yana qisqartirardi.
 */
export function displayPhone(value: string | null | undefined, revealed: boolean): string | null {
  if (value === null || value === undefined || value.trim() === '') return null
  if (isAlreadyMasked(value)) return value
  return revealed ? value : maskPhone(value)
}
